const errorCodeMessages: { [key: string]: string } = {
  EntityNotFoundError: "Nie znaleziono.",
  EntityAlreadyExistsError: "Ten rekord już istnieje.",
  PermissionDeniedError:
    "Nie masz wystarczających uprawnień do wykonania tej operacji.",
  P88ConnectionFailed: "Nie udało się połączyć z P88.",
  P88KlientNotFound: "Nie znaleziono klienta P88.",
  OrderAlreadyExists: "P88: Zamówienie już istnieje.",
  P88IncorrectBuyerAddress: "P88: Błędny lub nie znaleziony odbiorca.",
  P88IncorrectDeliveryAddress:
    "P88: Błędne lub nie znalezione miejsce dostawy.",
  P88IncorrectOrderDate: "P88: Błędna data zamówienia (< od bieżącej).",
  P88OrderItemNotFound: "P88: Nie znaleziona pozycja zamówienia.",

  NegativePriceError: "Cena nie może być ujemna.",
  NonPositiveQuantityError: "Ilość musi być większa niż 0.",
};

export function getErrorMessage(error: { code: string; message: string }) {
  return errorCodeMessages[error.code] || error.message;
}
